import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
// import ResidentReportTable from "./ResidentReportTable";
// import VisitorsReportTable from "./VisitorsReportTable";
import VisitorsReportNewList from "./VisitorsReportNewList";
// import AmenitiesTable from "./AmenitiesTable";

function VisitorsReport() {
  // const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Reports</h1>
            <Button
              className="contentTopLefBt"
              //   onClick={handleClickOpen("body")}
            >
              Download
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <VisitorsReportTable /> */}
              <VisitorsReportNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default VisitorsReport;
